export default __webpack_public_path__ + "img/send-outlook.6a14a35e.svg";